export default __webpack_public_path__ + "static/media/Group 405.0f00cfb4.png";